module.exports = __webpack_public_path__ + "assets/get-success-1b841d77.png";